import { render } from "./PopinVideoNotif.vue?vue&type=template&id=175dcadb&scoped=true"
import script from "./PopinVideoNotif.vue?vue&type=script&lang=js"
export * from "./PopinVideoNotif.vue?vue&type=script&lang=js"

import "./PopinVideoNotif.vue?vue&type=style&index=0&id=175dcadb&lang=scss&scoped=true"

import exportComponent from "C:\\Users\\Anael\\Documents\\developpement\\teachup-video-interactive\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-175dcadb"]])

export default __exports__